interface EmptyStateProps {
  heading?: React.ReactNode;
  icon: React.ReactNode;
  message?: React.ReactNode;
  primaryAction?: React.ReactNode;
}

export function EmptyState({ heading, icon, message, primaryAction }: EmptyStateProps) {
  return (
    <div className="px-4 py-12 text-center">
      <div className="flex place-content-center text-gray-400 *:size-12">{icon}</div>

      {!!heading && <h3 className="text-sm font-medium text-gray-900 not-empty:mt-2">{heading}</h3>}

      {!!message && <p className="text-sm text-gray-500 not-empty:mt-1">{message}</p>}

      {!!primaryAction && <div className="not-empty:mt-6">{primaryAction}</div>}
    </div>
  );
}
